import WWMethods from './WWMethods'
import jstz  from 'jstz';
import {message, Select, Radio, Input} from 'antd';
import moment from "moment";
const Option = Select.Option;
import {RouteUtil} from "@/routers";
import {wwConstants} from "@/tools";
import WWConstants from "./WWConstants";
import {MapConstant} from "@ww/leaflet-component";
import React from "react";
const {vinInfo,deviceInfo} = wwConstants;
export default class WWUtils{
    constructor() {

    }

    /**
     * fetch
     * @param:url,method,resolve(callBack of success),body,
     * @desc lockClicked 防止多次点击
     */
    static fetch() {
        let that = this;
        let argument=arguments;
            setTimeout(()=>{
                argument= Array.apply([], argument);
                const callBack=argument.filter((item)=>(item instanceof Function));
                const parameters=argument.filter((item)=>(!(item instanceof Function)));
                if (!argument[0] || !argument[1] || !argument[2]) {
                    if(callBack[2]){
                        callBack[2]('Cannot parse undefined or null');
                    }

                    throw new TypeError('Cannot parse undefined or null');
                }
                let options = {
                    method:argument[1],
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json; charset=utf-8"
                    },
                    credentials: 'include',
                };
                if ((parameters[1] === 'POST' || parameters[1] === 'PUT'|| parameters[1] === 'DELETE') && parameters[2]) {
                    options.body = JSON.stringify(parameters[2])
                }
                let url=parameters[0].trim();
                if (url.indexOf('/') !== 0) {
                    url = "/" + url;
                }
                fetch(that.getNoCacheURL(url), options, 3000).then((response) => {
                    if (response.status === 401) {
                        WWMethods.toLoginPageForSessionExpired(response);
                        WWMethods.logout(true);
                    } else if(response.status === 504) {
                        message.error(Strings.rs10655);
                    } else {
                        return response.json();
                    }
                }).then((data) => {
                    if(data.code === 401){
                        WWMethods.toLoginPageForSessionExpired(response);
                        WWMethods.logout(true);
                    }else{
                        callBack[0](data);
                    }
                }).catch((error) => {
                    if(callBack[2]){
                        callBack[2](error)
                    }

                });
            }, 0);
    }
    /**
     * 组装URL,url增加时间戳，语言
     * */
    static getNoCacheURL(url) {
        /**
         * 字符串拼接
         * @constructor
         */
        function StringBuilder(str) {
            this.data = new Array(str);
        }
        StringBuilder.prototype.append = function () {
            this.data.push(arguments[0]);
            return this;
        };
        StringBuilder.prototype.toString = function () {
            return this.data.join('');
        };
        let newURL = new StringBuilder(url);
        if (url.indexOf("?") > -1) {
            newURL.append("&v=").append(moment().unix());
        } else {
            newURL.append("?v=").append(moment().unix());
        }
        const language = localStorage.getItem('language')?localStorage.getItem('language'):'zh';
        console.log(language)
        if (!this.isNull(language)) {
            newURL.append(`&lang=${language}`)
        }
        newURL.append("&source=25");//todo source值待定
        if (url.indexOf('/') !== 0) {
            newURL = `/${newURL}`;
        }

        return encodeURI(newURL.toString());
    }
    //获取区域
    static getZoneName() {
        const timezone = jstz.determine();
        if(timezone && timezone.name){
            return timezone.name();
        }
        return ""
    }
    /**
     * isNull
     * 作用：判断是否为空
     * @param:str:String || float
     */
    static isNull(str) {
        return (str === null || str === undefined || String(str).replace(/\s+/g, '') === '');
    }
    static isNumber(str){
        return WWConstants.regExp.number.test(str.toString());
    }
    /**
     *
     * 作用：复制固定文本到粘贴板
     *
     */
    static copy (text) {
        if(text){// text是复制文本
            // 创建input元素
            const el = document.createElement('input')
            // 给input元素赋值需要复制的文本
            el.setAttribute('value', text)
            // 将input元素插入页面
            document.body.appendChild(el)
            // 选中input元素的文本
            el.select()
            // 复制内容到剪贴板
            document.execCommand('copy')
            // 删除input元素
            document.body.removeChild(el)
            message.success(Strings.copySuc || "复制成功")
        }
    }
    /**
     * Tree 树组件用到
     * 根据平台判断，将风控接口的数据转换成组件（RMS格式）可以识别的数据格式。
     * @param data
     * @param platform
     */
    static dataTransferTree(data, platform) {
        if (platform === 'gps') {
            const newDate = { };
            newDate.resultBean = data.resultBean;
            if (data && data.resultBean) {
                if (data.resultBean.code === 0) {
                    newDate.organizationId = data.accountId;
                    newDate.parentId = data.parentId ? data.parentId : data.accountId;
                    newDate.name = data.userName;
                    newDate.accountStatsBean=data.accountStatsBean
                    if (data.isLeaf) { newDate.isLeaf = data.isLeaf; }
                    if (data.subAccountBeanList) {
                        newDate.subOrganizationList = [];
                        data.subAccountBeanList.forEach((d) => {
                            newDate.subOrganizationList.push({
                                name: d.userName,
                                organizationId: d.accountId,
                                parentId: d.parentId,
                                isLeaf: d.isLeaf,
                                accountStatsBean:d.accountStatsBean
                            });
                        });
                    }
                }
            }
            return newDate;
        }
        return data;
    }
    /**
     * MyAutoComplete 树搜索下拉控件用到
     * 根据平台判断，将风控接口的数据转换成组件（RMS格式）可以识别的数据格式。
     * @param data 要转换的数据
     * @param platform 平台 风控:gps  RMS：rms
     */
    static dataTransferAutoComplete(data, platform) {
        if (platform === 'gps') {
            const newDate = { data: [] };
            newDate.resultStatusBean = data.resultBean;
            if (data && data.resultBean) {
                if (data && data.resultBean.code === 0) {
                    data.beanList.forEach((d) => {
                        newDate.data.push({
                            name: d.userName,
                            organizationId: d.accountId,
                            parentId: d.parentId,
                            parentName: d.parentName,
                            userAccount: d.userAccount,

                        });
                    });
                }
            }
            return newDate;
        }
        return data;
    }

    /**
     * moment返回YYYY-MM-DD 传入时间戳格式为秒
     * @param time
     * @returns {string|string}
     */
    static formatTimeYMD(time){
        if(time && time.toString().length === 10){
            time = time *1000;
        }
        return time?moment(time).format("YYYY-MM-DD"):"";
    }

    /**
     * moment返回YYYY-MM-DD HH:mm:ss 传入时间戳格式为秒
     * @param time
     * @returns {string|string}
     */
    static formatTimeYMDHms(time){
        if(time && time.toString().length === 10){
            time = time *1000;
        }
        return time?moment(time).format("YYYY-MM-DD HH:mm:ss"):"";
    }
    //时间格式转化
    static formatTime(time){
        return time?time.toString().length === 12 ?time*1000:time:null;
    }
    /**
     * 新增tab
     * @param key
     * @param title
     * @param params
     */
    static addNavigationTab(key,title,params){
        let choosedTabs = localStorage.getItem("chosedTabs") ?JSON.parse(localStorage.getItem("chosedTabs")):[];
        let isInChosedTabs = choosedTabs &&  choosedTabs.filter((item)=> item.key === key).length;
        const urlJson = RouteUtil.urlJson;
        let key_url = key;
        if(key.indexOf("2-2-")>-1){
            key_url = "2-2"
        }
        if(!isInChosedTabs){
            let newTab = {
                key:key,
                title:title,
                url:urlJson[key_url],
            }
            //车辆详情实时工况需要刷新，传参
            if((key.indexOf("2-2-")>-1 || key.indexOf("4-1-")>-1) && params){
                newTab.params = JSON.stringify(params)
            }
            choosedTabs.push(newTab)
            localStorage.setItem("chosedTabs",JSON.stringify(choosedTabs));
        }else{//编辑之类的组件更新标题
            let temp_chosedTab = choosedTabs.map((item)=>{
                if(item.key === key){
                    item.title = title;
                }
                return item;
            })
            localStorage.setItem("chosedTabs",JSON.stringify(temp_chosedTab));
        }
        //更新缓存中选中的tab
        localStorage.setItem("setTabActiveKey",key);
    }

    /**
     * 删除tab或者关闭tab
     * @param targetKey
     * @param activeKey
     * @param callback
     */
    static removeTab(targetKey,activeKey,callback){
        let target_temp = targetKey;
        let newActiveKey = activeKey;
        let lastIndex = -1;
        let items = localStorage.getItem("chosedTabs")?JSON.parse(localStorage.getItem("chosedTabs")): [];
        items.forEach((item, i) => {
            if (item.key === target_temp) {
                lastIndex = i - 1;
            }
        });
        //过滤掉要删除的tab
        const newPanes = items.filter((item) => item.key !== target_temp);
        //删除的是当前选中的tab,并且剩余的打开的tab不为空,重新选定选中的tab
        if (newPanes.length && newActiveKey === target_temp) {
            if (lastIndex >= 0) {
                newActiveKey = newPanes[lastIndex].key;
            } else {
                newActiveKey = newPanes[0].key;
            }
        }
        //更新缓存中的tab数据
        localStorage.setItem("chosedTabs",JSON.stringify(newPanes));
        callback && callback(newActiveKey);
        localStorage.setItem("setTabActiveKey",newActiveKey)
    }

    /**
     * 据全局枚举定义生成对应key的下拉框选项,radio,checkbox
     * @param key
     * @param type
     * @param autoSearch //是否自动搜索，在option中搜索
     * @returns {*|null}
     */
    static getOptionsFromGlobalEnums(key,type,autoSearch){
        let globalEnums = JSON.parse(localStorage.getItem("globalEnums"));
        if(globalEnums && globalEnums[key]){
            if(type === "select"){//下拉框
                if(autoSearch){
                    return globalEnums[key].map((item)=>{
                        return {value:item.code,label:item.name}
                    })
                }else{
                    return globalEnums[key].map((item)=>{
                        return <Option key={item.code} value={item.code}>{item.name}</Option>
                    })
                }

            }else if(type === "radio"){
                return globalEnums[key].map((item)=>{
                    return <Radio key={item.code} value={item.code} title={item.name}>
                        {item.value ?<img src={item.value} title={item.name}></img>:null}
                    </Radio>
                })
            }else if(type === "checkbox"){
              /*  return globalEnums[key].map((item)=>{
                    return <Option key={item.code} value={item.code}>{item.name}</Option>
                })*/
            }else{
                return globalEnums[key]
            }

        }else{
            return null;
        }
    }
    static getIconIDURLMap(iconId){
       const iconList =  this.getOptionsFromGlobalEnums("enums.carModelIcon");
       if(iconList && iconList.length && iconId){
           let filteredIcon = iconList.filter((icon_item)=>icon_item.code === iconId )[0];
           if(filteredIcon &&filteredIcon.value) {
               return filteredIcon.value;
           }else{
               return "";
           }
       }else{
           return ""
       }
    }
    /**
     * 据全局枚举定义生成对应key的文本值
     * @param key
     * @param type
     * @param value
     * @returns {*|null}
     */
    static getLabelFromGlobalEnums(key,type,value){
        let arr_key = this.getOptionsFromGlobalEnums(key,type);
        if(arr_key.length && !this.isNull(value)){
            let filterd_obj = arr_key.filter((item)=>item.code === value.toString())[0];
            if(filterd_obj && filterd_obj.name){
                return filterd_obj.name;
            }else {
                return ""
            }

        }else{
            return ""
        }
    }

    /**
     * 日历转化为秒组装
     * @param value
     * @returns {{start: number, end: number}|null}
     */
    static getTimeFromCalendar(value){
        return value ? {start:moment(value[0]).startOf("day").unix(),end:moment(value[1]).endOf("day").unix()}:null;
    }

    /**
     * 按照日期，时分秒；格式输出文本
     * @param type
     * @param value
     */
    static getInputShowText(type,value){
        if(this.isNull(value)){
            return ""
        }else{
            if(type === "day"){
                return  WWUtils.formatTimeYMD(value);
            }else if(type === "time"){
                return WWUtils.formatTimeYMDHms(value);
            }else{
                return value;
            }
        }
    }

    /**
     * 只能输入数字和字母
     * @param val
     * @returns {*}
     */
    static onlyNumberA(val){
        if(val){
            return  val.replace(/[^\w\.\/]/g,'');
        }else{
            return val;
        }
    }
    /**
     * 只能输入数字
     * @param val
     * @returns {*}
     */
    static onlyNumber(val){
        if(val){
            return  val.replace(/[^\w\.\/]/g,'');
        }else{
            return val;
        }
    }
    /**
     *
     * @param {} data 查询到的数据
     * @param {*} params 从常量文件中取到的本页面统计字段
     * @returns
     */
    static formatStData  (data,params){
        return  params.map((item)=>{
                return {
                    key:item.key,
                    count:data[item.key+"Desc"],
                    iconClass:item.icon,
                    desc:data[item.key+"Text"]
                }
            })
    }
    //获取不同地图类型对应的坐标系值
    static getMapTypeCoordinate(mapType){
        let coordinate = wwConstants.mapType_coordinate.filter((item)=> item.value == mapType);
        return coordinate && coordinate.length ? coordinate[0].coordinate:"bd09ll";
    }
    //获取详细地址
    static  getAddressDetail(lat,lng,mapType,callback) {
        let address = "";
        let url = WWMethods.getApiUrl("getAddress") + '?lat=' + lat + '&lng=' + lng + '&mapType=' + Type + "&coordinate=" + this.getMapTypeCoordinate(mapType);
        this.fetch(this.getNoCacheURL(url), "GET", (data) => {
            if (data.code === 0) {
                address = data.data;
                callback(address)
            }
        })
    }
    //获取当前地图类型
    static getCurMapType(){
        let mapTypelocal = localStorage.getItem("mapType");
        if(mapTypelocal === "Baidu_Map"){
            return "1"
        }else{
            return "0"
        }
    }
    static getZoom(meter){
        let zoom;
        if(meter < 100){
            zoom = 19;
        }else if(meter >= 100 && meter < 150){
            zoom = 18;
        }else if(meter >= 150 && meter < 300){
            zoom = 17;
        }else if(meter >= 300 && meter < 600){
            zoom = 16;
        }else if(meter >= 600 && meter < 1500){
            zoom = 15;
        }else if(meter >= 1500 && meter < 3000){
            zoom = 14;
        }else if(meter >= 3000 && meter < 6000){
            zoom = 13;
        }else if(meter >= 6000 && meter < 10000){
            zoom = 12;
        }else if(meter >= 10000 && meter < 20000){
            zoom = 11;
        }else if(meter >= 20000 && meter < 30000){
            zoom = 11;
        }else if(meter >= 30000 && meter < 60000){
            zoom = 10;
        }else if(meter >= 60000 && meter < 150000){
            zoom = 9;
        }else if(meter >= 150000 && meter < 300000){
            zoom = 8;
        }else if(meter >= 300000 && meter < 600000){
            zoom = 7;
        }else if(meter >= 600000 && meter < 1500000){
            zoom = 6;
        }else if(meter >= 1500000 && meter < 3000000){
            zoom = 5;
        }else if(meter >= 3000000 && meter < 6000000){
            zoom = 4;
        }else if(meter >= 6000000 && meter < 7500000){
            zoom = 3;
        }else if(meter >= 7500000 && meter < 15000000){
            zoom = 2;
        }else if(meter >= 15000000 && meter < 30000000){
            zoom = 1;
        }else{
            zoom = 1;
        }
        return zoom;
    }
    //获取香港澳门的简称
    static getBriefTitle(val){
        let name = val;
        if(val.indexOf(Strings.xiangganinfo ||'香港特别行政区')>-1){
            name =Strings.xianggan || '香港';
        }
        if(val.indexOf('澳门特别行政区')>-1){
            name =  Strings.aomen ||'澳门';
        }
        return name;
    }
    /*
    获取初始化的地图类型
    */
    static getInitMapType() {
        let  mapType = MapConstant.type.baiDu
        return mapType;
    }
    /**
     * 数据适配
     * @param item
     */
    static  dataMapping(item, index,type) {
        let device = {};
        for (let key in item) {
            let text = item[key];
            if(type==="gps"){
                for (let field in fieldMapper) {
                    let _key = monitorFieldMapper[field];
                    if (String(key) === String(_key)) {
                        device[field] = text;
                    }
                }
            }else {
                for (let field in fieldMapper) {
                    let _key = fieldMapper[field];
                    if (String(key) === String(_key)) {
                        device[field] = text;
                    }
                }
            }

        }
        return device;
    }
    /**
     * 数据转换
     * @param data
     */
    static convertToDeviceList(data,type) {
        let deviceList = [];
        if (data instanceof Array) {
            data.map((item, index) => {
                deviceList.push(this.dataMapping(item, index,type));
            });
        }
        return deviceList;
    };
    //去除空格
    static trimStr(str) {
        return str.replace(/\s+/g, '');
    }
    // 是否是国内环境
    static isChina() {
        return ISCHINA == 1;
    }
    //获取客户配合的机械类别
    static  getMachineTypeOptions(){
        let cus_supM  = localStorage.getItem("suppMachineTypeList")
        let cus_sup_m_arr = cus_supM?JSON.parse(cus_supM):[]
        let machine_arr =  this.getOptionsFromGlobalEnums("enums.machineType")
        return machine_arr && machine_arr.length ? machine_arr.map((item)=>{
            if(cus_sup_m_arr.includes(item.code)){
                return <Option key={item.code} value={item.code}>{item.name}</Option>
            }else{
                return ""
            }
        }):""
    }
}

/**
 * 字段与返回值对应关系
 */
const fieldMapper = {
    imei: 1,
    name: 2,
    isWireless: 3,
    status: 4,
    gpsTime: 5,
    heartTime: 7,
    statusTime: 8,
    lat: 9,
    lng: 10,
    locationType: 11,
    course: 12,
    speed: 13,
    accStatus: 14,
    accTime: 15,
    chargePercentage: 16,
    iconId:17,
    groupId: 18,
    groupName: 19,
    carOwner: 20,
    vehicleId:21,
    vin:22,
    licenseNumber:23,
    organizationId:24,
    organizationName:25,
    durationTime:27,
    totalHistoryMileage:28,
};
const monitorFieldMapper = {
    imei: 0,
    name:2,
    carName: 26,
    status: 13,
    gpsTime: 7,
    isWireless: 3,
    lat: 9,
    lng: 10,
    speed: 12,

};
